import script from "./diamondsSearchFormNumberRange.vue?vue&type=script&setup=true&lang=ts"
export * from "./diamondsSearchFormNumberRange.vue?vue&type=script&setup=true&lang=ts"

import "./diamondsSearchFormNumberRange.vue?vue&type=style&index=0&id=4027837a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4027837a"]])

export default __exports__